// Registro del Service Worker (Fase 3 del modo offline / PWA instalable).
//
// Solo en producción: en desarrollo un SW cachearía bundles viejos y pelearía
// con el hot-reload de CRA. Se registra después del load para no competir con
// el primer render. updateViaCache:'none' obliga al navegador a revalidar el
// sw.js en cada visita (no servirlo de un caché viejo) — clave para desplegar
// arreglos sin que la gente quede pegada en una versión vieja.

export function registrarServiceWorker() {
  if (process.env.NODE_ENV !== 'production') return;
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { updateViaCache: 'none' })
      .then((reg) => {
        // Si aparece una versión nueva, la activamos sin forzar doble recarga.
        reg.addEventListener('updatefound', () => {
          const nuevo = reg.installing;
          if (!nuevo) return;
          nuevo.addEventListener('statechange', () => {
            if (nuevo.state === 'installed' && navigator.serviceWorker.controller) {
              nuevo.postMessage?.('skipWaiting');
            }
          });
        });
      })
      .catch(() => { /* sin SW, la app sigue funcionando normal */ });
  });
}
